
import { defineComponent } from "vue";

export default defineComponent({
  name: "ShiftDetailsItemSkeleton",
  setup() {
    return {};
  },
});
